var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_504",
    transform: "translate(0 -0.05) scale(0.0208333 0.0229167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_504",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAABbklEQVRYCe3BzyvDcRzH8VdJUdtSrPzK1P4JZ3EVJzkqbg78C3Nxc+Di4A+gpKUUJblKLr4pNXPaaaXFCsmeKAc+vr+273u3PR7q6GgPsixxSIlnatxwxCJ9ctDHIkfcUOOZEocskVUcpChQx/XKJhn9IMMmr7jqFEgpHHk8glSY1BcmqRDEI69g5KkS5oUZZnghTJW8/JHCI8o770TxSMkPBawU9B9Z6lipk5WLZSwty0URS0W5uMPSnVw8YelJLmpYqsmFhyVPLo6xdCwXa1hak4tRGlhpMKr/OMPKmfwwQQMLDSbkjz0s7CsIYzyS1CNjCsYsSc0pHFsksa0odHNCq07pVjTSXNOKa9KKh0HuaVaZIcVHjjLNeCCn5pCjTFwPjKt55LgnjjLjag3DeES5ZUSto59LwlwxoGRIc06QCzJKjh4O8FOkVzboYgfXLl2yxDq/bcgeK3zw7YNVtQfzvPHGgtqHKabV0fHXJ8C7CzTmBzuhAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileHeart);
export default __webpack_public_path__ + "static/media/profileHeart.c8453df537327f09af2d9b1cb0ea580f.svg";
export { ForwardRef as ReactComponent };